import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MessageText\CreateMessageTextController::__invoke
* @see app/Http/Controllers/MessageText/CreateMessageTextController.php
* @route '/api/message-text'
*/
const CreateMessageTextController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateMessageTextController.url(options),
    method: 'post',
})

CreateMessageTextController.definition = {
    methods: ["post"],
    url: '/api/message-text',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\MessageText\CreateMessageTextController::__invoke
* @see app/Http/Controllers/MessageText/CreateMessageTextController.php
* @route '/api/message-text'
*/
CreateMessageTextController.url = (options?: RouteQueryOptions) => {
    return CreateMessageTextController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\MessageText\CreateMessageTextController::__invoke
* @see app/Http/Controllers/MessageText/CreateMessageTextController.php
* @route '/api/message-text'
*/
CreateMessageTextController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateMessageTextController.url(options),
    method: 'post',
})

export default CreateMessageTextController